import React, { useState } from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import MasterDataApiExplorer from '../../components/MasterDataApiExplorer';
import '../PageStyles.css';
import './MasterDataPage.css';

const sampleData = [
  { id: 'doc_001', customer_id: 'CZE000001', document_type: 'passport', status: 'verified' },
  { id: 'doc_002', customer_id: 'CZE000002', document_type: 'id_card', status: 'pending' },
];

const MasterDataCustomerDocuments = () => {
  const [showTryApi, setShowTryApi] = useState(false);

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Customer Documents</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Customer ID</th>
                <th>Document Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {sampleData.map((row) => (
                <tr key={row.id}>
                  <td><code>{row.id}</code></td>
                  <td><code>{row.customer_id}</code></td>
                  <td>{row.document_type}</td>
                  <td>
                    <span className={`status-badge ${row.status.toLowerCase()}`}>{row.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <MasterDataApiExplorer slug="customer-documents"  onClose={() => setShowTryApi(false)} />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MasterDataCustomerDocuments;
